import * as API from 'constants/api'
import * as ACTION_TYPES from 'constants/actionTypes'
import { SERVICES_PROCEDURE_LIST } from 'constants/actionTypes'
import axios, { getPayloadFromError, getPayloadFromSuccess } from 'utils/axios'
import { sprintf } from 'sprintf-js'

export const servicesCreateAction = params => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .post(API.TREATMENTS_CREATE, params)
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_CREATE}`,
      payload
    })
  }
}

export const servicesListAction = (params) => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .get(API.TREATMENTS_LIST, { params })
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_LIST}`,
      payload
    })
  }
}

export const servicesDiagnosisListAction = (params) => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .get(API.TREATMENTS_LIST, { params })
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_DIAGNOSIS_LIST}`,
      payload
    })
  }
}

export const servicesProcedureListAction = (params) => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .get(API.TREATMENTS_LIST, { params })
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_PROCEDURE_LIST}`,
      payload
    })
  }
}

export const servicesUpdateAction = (id, params) => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .put(sprintf(API.TREATMENTS_UPDATE, id), params)
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_CREATE}`,
      payload
    })
  }
}
export const servicesDeleteAction = id => {
  return (dispatch, getState) => {
    const payload = axios({ dispatch, getState })
      .delete(sprintf(API.TREATMENTS_DELETE, id))
      .then(getPayloadFromSuccess)
      .catch(getPayloadFromError)

    return dispatch({
      type: `${ACTION_TYPES.SERVICES_DELETE}`,
      payload
    })
  }
}
